package songwritersnotebook.app.data

import kotlinx.serialization.Serializable

@Serializable
enum class RoadmapStatus {
    SUGGESTED,
    APPROVED,
    IN_PROGRESS,
    ON_HOLD,
    COMPLETED
}

@Serializable
enum class RoadmapItemType {
    FEATURE,
    BUG,
    IMPROVEMENT
}

@Serializable
data class RoadmapItem(
    val id: String = "",
    val title: String = "",
    val description: String = "",
    val status: RoadmapStatus = RoadmapStatus.SUGGESTED,
    val type: RoadmapItemType = RoadmapItemType.FEATURE,
    val upvotes: Int = 0,
    val downvotes: Int = 0,
    val createdAt: Long = 0L,
    val voteCount: Int = 0, // Net score: upvotes - downvotes
    val authorId: String? = null, // Legacy field
    val authorIds: List<String> = emptyList()
) {
    val authors: List<String> get() = if (authorIds.isNotEmpty()) authorIds else listOfNotNull(authorId)
}

@Serializable
data class RoadmapVote(
    val userId: String,
    val itemId: String,
    val voteType: Int // 1 for up, -1 for down, 0 for none
)

@Serializable
data class RoadmapComment(
    val id: String = "",
    val itemId: String = "",
    val authorId: String = "",
    val text: String = "",
    val createdAt: Long = 0L
)
